import { render, staticRenderFns } from "./NGA.vue?vue&type=template&id=fba20ed6&scoped=true&"
import script from "./NGA.vue?vue&type=script&lang=js&"
export * from "./NGA.vue?vue&type=script&lang=js&"
import style0 from "./NGA.vue?vue&type=style&index=0&id=fba20ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba20ed6",
  null
  
)

export default component.exports